module.exports = __webpack_public_path__ + "static/media/bench-accounting-MGaFENpDCsw-unsplash.fdd91c04.jpg";